import { Box, FileText, Folder, List, Settings, Sliders, Users } from 'lucide-react';
import type { RouteProp } from '@/shared/types/route-prop';

export const customerRoutes: RouteProp[] = [
  {
    to: '/c/my-objects',
    icon: Box,
    label: 'navigation.items.customerObjects',
    children: [
      {
        to: '/c/my-objects',
        icon: List,
        label: 'navigation.items.allObjects',
      },
    ],
    dynamicChildren: 'object-categories',
  },
  {
    to: '/c/my-customer/customer',
    icon: Users,
    label: 'navigation.items.customerProfile',
  },
];

export const createCustomerRoutes = () => customerRoutes;

export const gmnRoutes: RouteProp[] = [
  {
    to: '/gmn/contract-management/contracts',
    icon: FileText,
    label: 'navigation.items.gmnContracts',
  },
  {
    to: '/gmn/contract-management/objects',
    icon: Box,
    label: 'navigation.items.gmnObjects',
    children: [
      {
        to: '/gmn/contract-management/objects',
        icon: List,
        label: 'navigation.items.allObjects',
      },
    ],
    dynamicChildren: 'object-categories',
  },
  {
    to: '/gmn/customer-management/customers',
    icon: Users,
    label: 'navigation.items.gmnCustomers',
  },
  {
    to: '/gmn/settings',
    icon: Settings,
    label: 'navigation.items.gmnSettings',
    children: [
      {
        to: '/gmn/settings/users',
        icon: Users,
        label: 'navigation.items.gmnUsers',
      },
      {
        to: '/gmn/settings/object-categories',
        icon: Folder,
        label: 'navigation.items.gmnObjectCategories',
      },
      {
        to: '/gmn/settings/metadata',
        icon: Sliders,
        label: 'navigation.items.gmnMetadata',
      },
    ],
  },
];
